import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import toastr from 'toastr';

export default {
  publicLinkController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$filter',
    'publicLinkService',
    'revision',
    'revisionService',
    '$uibModal',
    'webApiSettings',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $filter,
      publicLinkService,
      revision,
      revisionService,
      $uibModal,
      webApiSettings
    ) {
      'use strict';

      function loadRevision() {
        revisionService.findRevision(revision.id, false).then(function (data) {
          $scope.revision = data;
        });
      }

      function getLink() {
        var urlBase = window.location.origin + '/#/public/view/';
        publicLinkService.getPublicLinkShort(revision.id, urlBase).then(
          function (data) {
            if (webApiSettings.detailsCompany === 'abase') {
              $scope.documentLink = urlBase + data;
            } else {
              $scope.documentLink = data.shortLink;
            }

            if (revision.rowGuid === undefined) {
              revision.rowGuid = data.guid;
            }
            $scope.loading = false;
          },
          function (err) {
            // eslint-disable-next-line no-console
            console.error('error: ', err);
            $scope.showNotification('error', err.error_description);
            $scope.close();
          }
        );
      }

      function viewLink() {
        var pbLinkDate = new Date(revision.PublicLinkDate);
        pbLinkDate.getTime();

        if (revision.PublicLinkDate !== undefined) {
          if ($scope.publicDateRev >= $scope.Today) {
            const url = document.querySelector('#publicLink').value;
            window.open(url, '_blank');
          } else {
            swal.fire({
              title: 'Não é possivel visualizar este arquivo',
              text: 'O link do arquivo foi expirado',
              icon: 'info',
              showConfirmButton: true,
            });
          }
        } else {
          const url = document.querySelector('#publicLink').value;
          window.open(url, '_blank');
        }
      }

      function toggleEndDate() {
        $scope.isEndDateDisabled = !$scope.isEndDateDisabled;
      }

      function isExpired() {
        const valueInput = document.querySelector('#endDate').value;

        if (valueInput === '') {
          return false;
        }

        const DateToday = new Date();
        $scope.Today = DateToday.toISOString().substring(0, 10);

        var ArrayNotBar = valueInput.split('/');

        const ValueInputFormat = `${ArrayNotBar[2]}-${ArrayNotBar[1]}-${ArrayNotBar[0]}`;

        $scope.publicDateRev = ValueInputFormat;
        $scope.PublicLinkDateExpire = new Date(ValueInputFormat);

        if ($scope.publicDateRev >= $scope.Today) {
          return false;
        } else {
          return true;
        }
      }

      function cancelLink() {
        $scope.loading = true;
        $scope.loadingText = $filter('translate')(
          'LOADING CANCELING PUBLIC LINK'
        );

        var shortLink = $scope.documentLink;

        publicLinkService.cancelPublicLink(revision.id, null, shortLink).then(
          function () {
            revision.rowGuid = undefined;
            $scope.nextRevisionDate = '';
            $scope.close();
            $scope.showNotification('info', 'PUBLIC LINK CANCELED');
            $rootScope.loadDocs();
          },
          function (err) {
            $scope.showNotification('error', err.error_description);
            $scope.loading = false;
          }
        );
      }

      function notifyLinkCopy() {
        $scope.showNotification('info', 'PUBLIC LINK COPIED');
      }

      function showNotification(level, msg) {
        toastr.options = {
          closeButton: true,
          debug: false,
          progressBar: false,
          preventDuplicates: false,
          positionClass: 'toast-top-center',
          showDuration: '1000',
          hideDuration: '1000',
          timeOut: '7000',
          extendedTimeOut: '1000',
          showEasing: 'swing',
          hideEasing: 'linear',
          showMethod: 'fadeIn',
          hideMethod: 'fadeOut',
        };

        toastr[level]($filter('translate')(msg));
      }

      function close() {
        $rootScope.publicLinkModal.close();
      }

      function save() {
        if (document.activeElement) {
          document.activeElement.blur();
        }

        if ($scope.PublicLinkDateExpire !== undefined) {
          $scope.idRevision = revision.id;
          publicLinkService
            .postPublicLinkShortDateExpiration(
              $scope.idRevision,
              $scope.PublicLinkDateExpire
            )
            .then(function () {});
        }

        $rootScope.publicLinkModal.close();

        $rootScope.publicLinkModal.result.finally(function () {
            $rootScope.publicLinkSucessModal = $uibModal.open({
                animation: true,
                templateUrl: 'views/modal/successModal/successModal.html',
                controller: 'publicLinkController',
                windowClass: 'modal-center-window',
                backdrop: 'static',
                keyboard: true,
                size: 'm',
                resolve: {
                    revision: function () {
                        return revision;
                    }
                }
            });
        });
      }

      function closeSuccessModal() {
        $rootScope.publicLinkSucessModal.close();

        $rootScope.loadDocs();
      }

      function run() {
        try {
          $scope.documentLink = '';
          $scope.loading = true;
          $scope.loadingText = $filter('translate')('LOADING PUBLIC LINK');
          $scope.messageDescription = $filter('translate')('PUBLIC LINK SAVE');
          $scope.messageCancel = 'OK';
          $scope.messageTitle = $filter('translate')('PUBLIC LINK');

          $scope.publicDateRev;
          $scope.nextRevisionDate = revision.PublicLinkDate
            ? new Date(revision.PublicLinkDate)
            : null;
          $scope.isEndDateDisabled = false;

          $scope.loadRevision = logWrapper(
            loadRevision,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getLink = logWrapper(
            getLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.viewLink = logWrapper(
            viewLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.toggleEndDate = logWrapper(
            toggleEndDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isExpired = logWrapper(
            isExpired,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelLink = logWrapper(
            cancelLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.notifyLinkCopy = logWrapper(
            notifyLinkCopy,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showNotification = logWrapper(
            showNotification,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.close = logWrapper(
            close,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save = logWrapper(
            save,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeSuccessModal = logWrapper(
            closeSuccessModal,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
